import {useHistory} from "react-router-dom";
import {useEffect, useState} from "react";
import {Button, Card, Space, Table} from "antd";
import {t} from "i18next";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import ApiService from "../../core/service/ApiService";
import { FilterActions, SearchCard } from "../../core/components/quick-filter/QuickFilterParts";
import { matchesSearch } from "../../core/utils/text-search";
import AppLink from "../../core/components/AppLink";

export default function DoctorList()
{
    const history = useHistory();
    const [doctors, setDoctors] = useState([]);
    const [search, setSearch] = useState('')

    const getDoctors = async () => {
        const res = await ApiService.Doctor.GetDoctorList({})

        if(res.success)
        {
            setDoctors(res.data)
        }
    }

    const deleteDoctor = async (doctorId) => {
        const res = await ApiService.Doctor.DeleteDoctor(doctorId);

        if(res.success)
        {
            await getDoctors();
        }
    }

    useEffect(() => {
        getDoctors()
    }, [])

    const filteredData = search ? doctors.filter(x => matchesSearch(x.name, search)) : doctors

    return (
        <SimpleLayout fullWidth={true}>
            <div className="qf-row qf-row-top">
                <SearchCard value={search} onChange={setSearch} />
            </div>
            <FilterActions>
                <Button size={'small'} onClick={() => {history.push(`/app/system/doctors/create`)}} type={'primary'}>{t('New')}</Button>
                <Button size={'small'} onClick={getDoctors}>{t('Refresh')}</Button>
            </FilterActions>
            <Card>
                <Table
                    size={'small'}
                    dataSource={filteredData}
                    pagination={false}
                    columns={[
                        {dataIndex: 'name', key: 'name', title: t('Name')},
                        {dataIndex: 'units', key: 'units', title: t('Units'), render: (text, row) => row.units.map(x => x.name).join(', ')},
                        {dataIndex: '#', key: '#', title: t('#'), render: (text, row) => (
                                <Space>
                                    <AppLink key="edit" to={`/app/system/doctors/edit/${row.id}`}>{t('edit')}</AppLink>
                                    <a key="delete" onClick={async () => {await deleteDoctor(row.id)}} style={{color: 'red'}}>{t('Delete')}</a>
                                </Space>
                            )},
                    ]}
                />
            </Card>
        </SimpleLayout>
    )
}